import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AddProposalService } from 'src/app/views/proposals/add-proposal/add-proposal.service';

@Component({
  selector: 'app-add-dialog',
  templateUrl: './add-dialog.component.html',
  styleUrls: ['./add-dialog.component.css']
})
export class AddDialogComponent implements OnInit {
  public serviceLines: any = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  competencyCtrl = new FormControl('');
  subCompetencyControl = new FormControl([]);
  competencies: any[] = [];
  subServiceValues: any = [];
  isCompetencyFiledDisabled: boolean = false;
  competencySelected: any;
  defaultSubCompetencyId: number;
  public selectedCompetenyId: any;
  selectedSubCompetencies: any[] = [];

  @ViewChild('competencyInput') competencyInput: ElementRef<HTMLInputElement>;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddDialogComponent>,
    public _service: AddProposalService
  ) { }
  ngOnInit(): void {
    this.getServiceLines();
    this.subCompetencyControl.valueChanges.subscribe((newValue) => {
      this.subCompetencyControl.setValue(newValue, { emitEvent: false });
      // Update previousValues whenever the value changes
    });
  }

  onCompetencyChange(event) {
    this.selectedCompetenyId = event.value.id;
    this.isCompetencyFiledDisabled = true;
    this.subCompetencyControl.setValue([]);
    this.getSubServiceLineValues();
  }
  compareThem(value1, value2): boolean {
    return value1.name === value2.name;
  }
  getSubServiceLineValues() {
    this.defaultSubCompetencyId = 0;
    let competency = this.data.data.competencies.find(x => x.competencyId == this.selectedCompetenyId);
    if (competency) {
      let selectedSubCompetencies = competency.subCompetencies?.map(s => {
        if (s.isDefault) {
          this.defaultSubCompetencyId = s.subCompetencyId;
        }
        return { id: s.subCompetencyId, name: s.subCompetencyName, competencyId: this.selectedCompetenyId, isDefault: s.isDefault }
      });
      this.subCompetencyControl.setValue(selectedSubCompetencies);
    }
    this._service.getSubServiceLines(this.selectedCompetenyId).subscribe(x => {
      this.subServiceValues = [];
      x.data.forEach(ser => {
        if (this.defaultSubCompetencyId == ser.id) {
          ser.isDefault = true;
        }
        this.subServiceValues.push(ser);
      });

    });
  }

  getServiceLines() {
    this._service.getServiceLines().subscribe(x => {

      x.data.forEach(ser => {
        x = this.serviceLines.some(x => x.name == ser.name);
        if (!x) {
          this.serviceLines.push(ser);

        }
      });
    })
  }

  onSubCompetencyRemoved(subCompetency: any) {
    const subCompetencies = this.subCompetencyControl.value as any[];
    this.removeFirst(subCompetencies, subCompetency);
    this.subCompetencyControl.setValue(subCompetencies);
  }
  closeDialog() {
    let competency = this.data.data.competencies.find(x => x.competencyId == this.selectedCompetenyId);
    if (competency) {
      let existingSubCompetencies = competency.subCompetencies.map(sc => sc.subCompetencyId);
      let newSubCompetencies = this.subCompetencyControl.value.filter(s => !existingSubCompetencies.includes(s.id)).map(s => {
        return {
          subCompetencyId: s.id,
          subCompetencyName: s.name,
          primarySkills: [],
          secondarySkills: [],
          certificates: []
        }
      });
      let subCompetencies = competency.subCompetencies.concat(newSubCompetencies);
      competency.subCompetencies = subCompetencies.filter(s => this.subCompetencyControl.value.find(sc => sc.id == s.subCompetencyId));
    }
    else {
      this.data.data.competencies.push({
        competencyId: this.selectedCompetenyId,
        competencyName: this.serviceLines.find(c => c.id == this.selectedCompetenyId)?.name,
        subCompetencies: this.subCompetencyControl.value.map(s => {
          return {
            subCompetencyId: s.id,
            subCompetencyName: s.name,
            primarySkills: [],
            secondarySkills: [],
            certificates: []
          }
        })
      })
    }
    this.dialogRef.close(true);

  }

  removeFirst(array: any[], toRemove: any): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
}

